import React, { useEffect, useRef } from 'react';
import frontImage from '../assets/front2.jpeg';

const HERO_IMG = frontImage;

export default function Hero() {
  const titleRef = useRef(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    setTimeout(() => {
      el.style.transition = 'opacity 1.2s ease, transform 1.2s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 100);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <style>{`
        @keyframes fadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:none; } }
        @keyframes scrollPulse { 0%,100%{opacity:1;} 50%{opacity:0.25;} }
        @keyframes shimmer { 0%{background-position:200% center;} 100%{background-position:-200% center;} }
        .hero-btn-gold { background:#C9A84C; color:#0F1D48; font-family:'Jost',sans-serif;
          font-size:0.62rem; letter-spacing:4px; text-transform:uppercase; padding:1rem 2.4rem;
          border:none; cursor:pointer; font-weight:500; transition:all .35s; }
        .hero-btn-gold:hover { background:#E8C97A; transform:translateY(-2px); box-shadow:0 8px 24px rgba(201,168,76,.35); }
        .hero-btn-ghost { background:transparent; color:#F2E8D9; font-family:'Jost',sans-serif;
          font-size:0.62rem; letter-spacing:4px; text-transform:uppercase; padding:1rem 2.4rem;
          border:1px solid rgba(242,232,217,.35); cursor:pointer; font-weight:300; transition:all .35s; }
        .hero-btn-ghost:hover { border-color:#C9A84C; color:#C9A84C; }
        .scroll-down-cue { position:absolute;bottom:2.2rem;left:50%;transform:translateX(-50%);
          display:flex;flex-direction:column;align-items:center;gap:0.5rem; cursor:pointer; }
        .scroll-down-cue span { font-family:'Jost',sans-serif;font-size:0.52rem;letter-spacing:5px;
          text-transform:uppercase;color:rgba(242,232,217,.35); }
        .scroll-line { width:1px;height:38px;background:linear-gradient(to bottom,#C9A84C,transparent);
          animation:scrollPulse 2.3s ease infinite; }
      `}</style>

      <section style={{
        minHeight: '100vh', position: 'relative',
        display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
      }}>
        {/* Background */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: `url(${HERO_IMG})`,
          backgroundSize: 'cover', backgroundPosition: 'center',
        }} />
        {/* Overlay — warm skin tint */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(160deg, rgba(15,29,72,0.78) 0%, rgba(15,29,72,0.55) 50%, rgba(42,31,14,0.72) 100%)',
        }} />

        {/* Content */}
        <div ref={titleRef} style={{
          position: 'relative', textAlign: 'center',
          padding: '2rem 1.5rem', maxWidth: '900px', width: '100%',
        }}>
          {/* Lotus */}
          <div style={{ display:'flex', justifyContent:'center', marginBottom:'1.8rem',
            animation:'fadeUp .9s ease .1s both' }}>
            {/* <svg width="110" height="110" viewBox="0 0 120 120" fill="none" style={{filter:'drop-shadow(0 4px 20px rgba(201,168,76,.4))'}}>
              <circle cx="60" cy="60" r="55" stroke="#C9A84C" strokeWidth="1" fill="none" opacity=".4"/>
              {[...Array(16)].map((_,i)=>{
                const a=(i*22.5-90)*Math.PI/180;
                return <line key={i} x1={60+36*Math.cos(a)} y1={60+36*Math.sin(a)}
                  x2={60+50*Math.cos(a)} y2={60+50*Math.sin(a)} stroke="#C9A84C" strokeWidth="1.3" opacity=".65"/>;
              })}
              <path d="M22 75 Q60 92 98 75" fill="#1B2F6E" opacity=".95"/>
              {[0,60,120,180,240,300].map((deg,i)=>{
                const r=16, rad=deg*Math.PI/180;
                return <ellipse key={i} cx={60+r*Math.sin(rad)} cy={71-r*Math.cos(rad)*0.5}
                  rx="8" ry="14" transform={`rotate(${deg},${60+r*Math.sin(rad)},${71-r*Math.cos(rad)*0.5})`}
                  fill="#C9A84C" opacity=".55"/>;
              })}
              {[0,72,144,216,288].map((deg,i)=>{
                const r=9, rad=deg*Math.PI/180;
                return <ellipse key={i} cx={60+r*Math.sin(rad)} cy={68-r*Math.cos(rad)*0.6}
                  rx="5.5" ry="11" transform={`rotate(${deg},${60+r*Math.sin(rad)},${68-r*Math.cos(rad)*0.6})`}
                  fill="white" opacity=".92"/>;
              })}
              <ellipse cx="60" cy="66" rx="4.5" ry="9.5" fill="white"/>
              <ellipse cx="60" cy="66" rx="2" ry="6" fill="#C9A84C" opacity=".5"/>
            </svg> */}
          </div>

          {/* Eyebrow */}
          <p style={{
            fontFamily:"'Jost',sans-serif", fontSize:'0.6rem', letterSpacing:'7px',
            textTransform:'uppercase', color:'#C9A84C', marginBottom:'0.9rem',
            animation:'fadeUp .8s ease .3s both', fontWeight:300,
          }}>
            Welcome to
          </p>

          {/* Main title */}
          <h1 style={{
            fontFamily:"'Cinzel',serif", fontSize:'clamp(2.4rem,7vw,5.8rem)',
            fontWeight:600, color:'#fff', lineHeight:1, letterSpacing:'4px',
            animation:'fadeUp .8s ease .45s both',
          }}>
            SHREE MAYA
          </h1>
          <h2 style={{
            fontFamily:"'Cormorant',serif", fontSize:'clamp(1.8rem,5vw,3.8rem)',
            fontWeight:400, color:'#C9A84C', fontStyle:'italic', letterSpacing:'2px',
            marginBottom:'0.6rem', animation:'fadeUp .8s ease .58s both',
          }}>
            Comfort Inn
          </h2>

          {/* Tagline */}
          <p style={{
            fontFamily:"'EB Garamond',serif", fontSize:'clamp(0.85rem,1.8vw,1.05rem)',
            fontStyle:'italic', color:'rgba(242,232,217,.6)', letterSpacing:'3px',
            marginBottom:'2.5rem', animation:'fadeUp .8s ease .7s both',
          }}>
           Experience true hospitality
          </p>

          {/* Divider */}
          <div style={{
            display:'flex', alignItems:'center', gap:'0.9rem',
            justifyContent:'center', marginBottom:'2.8rem',
            animation:'fadeUp .8s ease .82s both',
          }}>
            <div style={{width:'55px', height:'1px', background:'#C9A84C'}}/>
            <div style={{width:'6px', height:'6px', background:'#C9A84C', transform:'rotate(45deg)'}}/>
            <div style={{width:'55px', height:'1px', background:'#C9A84C'}}/>
          </div>

          {/* Buttons */}
          <div style={{
            display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap',
            animation:'fadeUp .8s ease .95s both',
          }}>
            <button className="hero-btn-gold" onClick={() => go('rooms')}>Explore Rooms</button>
            <button className="hero-btn-ghost" onClick={() => go('contact')}>Contact Us</button>
          </div>
        </div>

        {/* Scroll cue */}
        <div className="scroll-down-cue" onClick={() => go('about')}>
          <span>Scroll</span>
          <div className="scroll-line"/>
        </div>
      </section>
    </>
  );
}
